

import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';

import HeaderComponent from '../header/header';
import MenuCategories from '../menu/category/categories';
import MenuItems from '../menu/items/items';
import ItemComponent from './itemComponent';
import UserComponent from '../user/user';

import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

import { loadMenu as loadMenuFromServer } from "../../../../utils/api/menuApiProxy"

const basketUtil = require('../../../../utils/basket/basketUtil.js');
const stateManager = require('../../../../utils/state/stateManager.js');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const currentComponentAction = require('../../../../utils/state/actions/component/currentComponentAction');
const menuCategoryAction = require('../../../../utils/state/actions/menuCategory/menuCategoryAction');
const formatter = require('../../../../utils/formatter/formatter.js');
const storeUtil = require('../../../../utils/store/storeUtil');
const stringUtil = require('../../../../utils/string/stringUtil');
const constants = require('../../../../utils/domain/constants');

class Store extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.isCategoryToolbarClicked = false;
        this.state.changedCategoryOnScrolling = false;
        
        this.state.lastScrollTop = 0;
        this.state.isScrollingUpDirection = false;
        
        this.state.itemDialogueItemCategoryIndex = -1;
        this.state.itemDialogueItemIndex = -1;
        this.state.adjustItemDialogueScrolling = false;
        this.state.scrollPositionBeforeItemDialogue = null;

        this.state.showUserDetailsBottomSheet = false;
      
        this.handleScroll =this.handleScroll.bind(this);
        this.renderUserDetailsBottomSheet = this.renderUserDetailsBottomSheet.bind(this);
    }

    render()
    {
        var style ={};
        if (this.state.itemDialogueItemIndex >= 0)
            style.display = "none";
            style.background = `var(--header-background-color)`;

        const storeClosed = storeUtil.isStoreClosed();
        if(storeClosed)
        {
            return <div>
                    <div style={style}>
                        <HeaderComponent/>
                        {this.renderStoreClosed()}
                    </div>
                </div>
        }
        else
        {
            return <div>
                    <div style={style}>
                        <HeaderComponent/>
                        {this.renderMenu()}
                        {this.renderViewBasketButton()}
                    </div>
                    {this.renderItemDialogue()}
                    {this.renderUserDetailsBottomSheet()}
                </div>
        }
    }

    componentDidMount()
    {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event)
    {
        if (this.state.adjustItemDialogueScrolling || this.state.scrollPositionBeforeItemDialogue != null)
            return;

        var currentMenu = stateManager.getStore().getState().currentMenu;

        if (currentMenu == null)
            return;

        this.state.isScrollingUpDirection = false;
        var st = window.pageYOffset || document.documentElement.scrollTop; 
        if (st > this.state.lastScrollTop) this.state.isScrollingUpDirection = true;
        this.state.lastScrollTop = st <= 0 ? 0 : st; 

        let nextIndex = 0;
        if (this.state.isScrollingUpDirection)
            nextIndex = this.findNextIndex(1);
        else
            nextIndex = this.findNextIndex(-1);
       
        if (nextIndex < 0 || nextIndex >= currentMenu.categories.length)
            return;

        let menuCategoryHeaderId = `menu-category-header-${nextIndex}`;
        var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);

        if (this.isInViewport(categoryHeaderElement))
        {
            stateManager.getStore().dispatch(menuCategoryAction.createAction(nextIndex));
            this.state.changedCategoryOnScrolling = true;
            return;
        }  
    }

    findNextIndex (delta)
    {
        var currentMenu = stateManager.getStore().getState().currentMenu;
        let nextIndex = this.props.currentMenuCategoryIndex;

        while(true)
        {
            nextIndex = nextIndex + delta;
            if (nextIndex < 0 || nextIndex >= currentMenu.categories.length)
                return -1;

            let menuCategoryHeaderId = `menu-category-header-${nextIndex}`;
            var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);
            if (categoryHeaderElement != null)
                return nextIndex;
        }
    }

    isInViewport(el) 
    {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    
        );
    }
  
    componentDidUpdate()
    {
        if (this.state.adjustItemDialogueScrolling)
        {
            window.scrollTo(0, 0);
            this.state.adjustItemDialogueScrolling = false;
            return;
        }

        if (this.state.scrollPositionBeforeItemDialogue != null)
        {
            window.scrollTo(0, this.state.scrollPositionBeforeItemDialogue);
            this.state.scrollPositionBeforeItemDialogue = null;
            return;
        }
        
        var currentMenu = stateManager.getStore().getState().currentMenu;
        if(currentMenu == null)
            return;

        let menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex}`;
        if (this.state.isScrollingUpDirection)
        {
            if (this.props.currentMenuCategoryIndex+1 < currentMenu.categories.length)
                menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex+1}`;
        }

        if (!this.state.isScrollingUpDirection)
        {
            if (this.props.currentMenuCategoryIndex-1 > 0)
                menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex-1}`;
        }


        let menuCategoryHeaderId = `menu-category-header-${this.props.currentMenuCategoryIndex}`;
        var categoryToolBarElement = document.getElementById(menuCategoryToolBarId);
        var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);

        if (this.state.isCategoryToolbarClicked && categoryHeaderElement != null)
        {
            this.state.isCategoryToolbarClicked = false;
            categoryHeaderElement.scrollIntoView(true,{behavior: "smooth", block: "start"});
        }

        if (this.state.changedCategoryOnScrolling && categoryToolBarElement != null)
        {
            this.state.changedCategoryOnScrolling = false;
            categoryToolBarElement.scrollIntoView(true,{behavior: "smooth",  block: 'start', inline: "start"});
        }
    }

    renderStoreClosed()
    {
        var background = 'var(--selected-background-color)';
        var color = 'var(--selected-font-color)';
        var fontSize =  'var(--font-size-xl)';

        return <div className='d-flex justify-content-center' >
            <div className='p-4 mt-5 rounded' style={{backgroundColor: background, color: color, fontSize: fontSize}}>Store is currently closed</div>
        </div>
    }

    renderMenu()
    {
        var state = stateManager.getStore().getState();

        if (state.currentMenu == null)
        {
            return this.loadMenu();
        }

        return <div>
                    <MenuCategories onClick={(categoryIndex)=>{this.state.isCategoryToolbarClicked = true;}}/>
                    <MenuItems onClick={(categoryIndex, category, itemIndex, item) => 
                                        {
                                            this.state.itemDialogueItemCategoryIndex = categoryIndex;
                                            this.state.itemDialogueItemIndex = itemIndex;

                                            this.state.adjustItemDialogueScrolling = true;
                                            this.state.scrollPositionBeforeItemDialogue = window.pageYOffset;

                                            this.setState({});
                                        }}/>
                </div>
    }

    renderViewBasketButton()
    {
        if (basketUtil.isBasketEmpty())
            return null;

        return  <div style={{textAlign:'center', 
                    position:'fixed', bottom:0, marginBottom:'0px', 
                    right:'0%', left:'0%', 
                    paddingBottom:'20px', 
                    paddingTop:'20px', 
                    borderTop:`var(--bottom-bar-top-border)`,
                    background:`var(--bottom-bar-background-color)`
                    
                    }}>
            
                    <Button color="primary" 
                    style={{
                            color:`var(--button-addToBasket-font-color)`, 
                            background:`var(--button-addToBasket-background-color)`,
                            borderColor:`var(--button-addToBasket-background-color)`,
                            fontSize:`var(--button-addToBasket-font-size)`,
                            fontWeight:'bold',
                            marginRight:'5px',
                            paddingLeft:'20px',
                            paddingRight:'20px',
                            paddingTop:'10px',
                            paddingBottom:'10px',
                            width:'80%',
                            borderRadius:15
                        }}
                onClick={()=>
                    {
                        this.onViewBasketClick();
                    }}>View Basket - {formatter.convertToCurrencyFormat(basketUtil.getTotalOrderPrice())}</Button>{' '}
                </div>
    }

    renderItemDialogue()
    {
        if (this.state.itemDialogueItemIndex < 0)
            return null;

        return <ItemComponent 
                    categoryIndex={this.state.itemDialogueItemCategoryIndex} 
                    itemIndex = {this.state.itemDialogueItemIndex}
                    onClose={(orderItem)=>
                            {
                                this.state.itemDialogueItemCategoryIndex = -1;
                                this.state.itemDialogueItemIndex = -1;

                                if (orderItem != null)
                                    basketUtil.addItemToBasket(orderItem);

                                this.setState({});
                            }}
                />
    }

    loadMenu()
    {
        loadMenuFromServer()
        .then(response =>
            {
                basketUtil.resetMenu(response.saleMenu, response.rewardMenu);
                
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });
        return <div style={{marginTop:'20px', marginLeft:'10px', marginRight:'10px'}}>
                    <div>
                        <ReactPlaceholder showLoadingAnimation={true} type='media' rows={3} ready={false} color={`var(--skeleton-color)`}/>
                   </div>

                   <div style={{marginTop:'30px'}}>
                        <ReactPlaceholder showLoadingAnimation={true} type='media' rows={3} ready={false} color={`var(--skeleton-color)`} />
                   </div>

                   <div style={{marginTop:'30px'}}>
                        <ReactPlaceholder showLoadingAnimation={true} type='media' rows={3} ready={false} color={`var(--skeleton-color)`} />
                   </div>

                   <div style={{marginTop:'30px'}}>
                        <ReactPlaceholder showLoadingAnimation={true} type='media' rows={3} ready={false} color={`var(--skeleton-color)`} />
                   </div>
                </div>
    }

    onViewBasketClick()
    {
        if(stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment))
            stateManager.getStore().dispatch(currentComponentAction.createAction("basket"));        
        else
        {
            this.state.showUserDetailsBottomSheet = true;
            this.setState({});
            return;
        }
    }

    renderUserDetailsBottomSheet()
    {
        if (!this.state.showUserDetailsBottomSheet)
            return;

        return <UserComponent 
                                onComplete={()=>
                                {
                                    stateManager.getStore().dispatch(currentComponentAction.createAction("basket"));
                                }}
                                onDismiss={()=>
                                    {
                                        this.state.showUserDetailsBottomSheet = false;
                                        this.setState({});
                                    }}/>
    }
}

const mapStateToProps = state => 
{
    return { 
        basketVersion: state.basketVersion,
        currentMenuCategoryIndex: state.currentMenuCategoryIndex,
    }
}

export default connect(mapStateToProps)(Store)